import { Accordion as PrimeAccordion } from "primereact/accordion";
import { forwardRef } from "react";

import { withDefaults } from "../../utils/with-defaults";
import { primeIcon } from "../icon";
import type { AccordionProps } from "./types-accordion";

/** Figma (❖ Accordion 232:9351): chevron-down no painel aberto e chevron-up no recolhido, os dois em 14. */
const COLLAPSE_ICON = primeIcon("chevron-down", 14);
const EXPAND_ICON = primeIcon("chevron-up", 14);

/**
 * `Accordion` do Prime com os chevrons do Figma como padrão; use `AccordionTab` (do Prime, reexportado) para cada painel.
 * O visual vem do tema (`prime-react/components/panel/accordion.scss`); `className="p-accordion-card"` deixa a moldura e
 * o cabeçalho (`headerTemplate`) para a tela.
 */
export const Accordion = forwardRef<PrimeAccordion, AccordionProps>(function Accordion(props, ref) {
  return (
    <PrimeAccordion
      ref={ref}
      {...withDefaults({ collapseIcon: COLLAPSE_ICON, expandIcon: EXPAND_ICON }, props)}
    />
  );
});
Accordion.displayName = "Accordion";
